import Spinner from 'src/components/Spinner';

import { ChildProps } from '../../interfaces/layout';
import { getChildrenOnDisplayName } from '../utils';

import Header from './components/Header';
import SearchAndFilter from './components/SearchAndFilter';
import SearchAndFilterWithChildren from './components/SearchAndFilterWithChildren';
import MainContent from './components/MainContent';
import Pagination from './components/Pagination';
import Footer from './components/Footer';
import { styles } from './styles';

const GenericScreenLayout = ({ children, isLoading = false }: { children: ChildProps | ChildProps[], isLoading?: boolean }) => {
  const { classes } = styles();
  const header = getChildrenOnDisplayName(children, 'Header');
  const searchAndFilter = getChildrenOnDisplayName(children, 'SearchAndFilter');
  const searchAndFilterWithChildren = getChildrenOnDisplayName(children, 'SearchAndFilterWithChildren');
  const mainContent = getChildrenOnDisplayName(children, 'MainContent');
  const pagination = getChildrenOnDisplayName(children, 'Pagination');
  const footer = getChildrenOnDisplayName(children, 'Footer');

  return (
    <div className={classes.mainContainer}>
      {header}
      {searchAndFilter}
      {searchAndFilterWithChildren}
      {isLoading ? (
        <Spinner fullContainer/>
      ) : (
        <>
          <div>
            {mainContent}
            {pagination}
          </div>
          <div>{footer}</div>
        </>
      )}
    </div>
  );
};

GenericScreenLayout.Header = Header;

GenericScreenLayout.SearchAndFilter = SearchAndFilter;

GenericScreenLayout.SearchAndFilterWithChildren = SearchAndFilterWithChildren;

GenericScreenLayout.MainContent = MainContent;

GenericScreenLayout.Pagination = Pagination;

GenericScreenLayout.Footer = Footer;

export default GenericScreenLayout;
